import { render, staticRenderFns } from "./SkeletonText.vue?vue&type=template&id=324f22a0&scoped=true"
import script from "./SkeletonText.js?vue&type=script&lang=js&external"
export * from "./SkeletonText.js?vue&type=script&lang=js&external"
import style0 from "./SkeletonText.scss?vue&type=style&index=0&id=324f22a0&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324f22a0",
  null
  
)

export default component.exports